import { render, staticRenderFns } from "./contactDetails.vue?vue&type=template&id=654dd53b&scoped=true"
import script from "./contactDetails.vue?vue&type=script&lang=js"
export * from "./contactDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654dd53b",
  null
  
)

export default component.exports